import { FaxTypes } from '@frontend/api-fax';
import { createShallowStore, createStoreWithPersistAndSubscribe } from '@frontend/store';

const DEFAULT_INBOX_FILTERS: FaxTypes.InboxFilters = {
  statusFilter: FaxTypes.FaxStatusFilter.ALL,
  isDelivered: '',
  tags: [],
  faxNumbers: [],
  startDate: '',
  endDate: '',
};

interface InboxFiltersStore {
  inboxFilters: FaxTypes.InboxFilters;
  setInboxFilters: (val: Partial<FaxTypes.InboxFilters>) => void;
  resetInboxFilters: () => void;
}

export const useInboxFiltersStore = createStoreWithPersistAndSubscribe<InboxFiltersStore>(
  (set) => ({
    inboxFilters: DEFAULT_INBOX_FILTERS,
    setInboxFilters: (args: Partial<FaxTypes.InboxFilters>) =>
      set(
        (state) => {
          state.inboxFilters = { ...state.inboxFilters, ...args };
        },
        false,
        'SET_FAX_INBOX_FILTERS'
      ),
    resetInboxFilters: () =>
      set(
        (state) => {
          state.inboxFilters = DEFAULT_INBOX_FILTERS;
        },
        false,
        'RESET_FAX_INBOX_FILTERS'
      ),
  }),
  { name: 'FaxInboxFiltersStorage', version: 4 },
  { name: 'FaxInboxFilters', trace: true }
);

export const useInboxFiltersShallowStore = createShallowStore(useInboxFiltersStore);
